<template>
  <div class="component">
    <b-container fluid class="pb-20 pt-30">
      <!-- Display all the avilable sites and other options -->
      <div>
        <div class="row">
          <div class="col-10">
            <div class="d-flex mb-3">
              <div class="mr-auto p-2">
                <input
                  type="text"
                  class="form-control input-lg mb-10 br-3 search-field"
                  placeholder="Search"
                  v-model="searchTerm"
                  @keyup.enter="searchSite(searchTerm)"
                  v-if="user.userRole !== 'Biostatistics' && user.userRole !== 'Pharmacovigilance' && user.userRole !== 'Pi' && user.userRole !== 'SubPi' && user.userRole !== 'StudyCoordinator' && user.userRole !== 'HomeHealth' && user.userRole !== 'CallCenter' && user.userRole !== 'Rater' && user.userRole !== 'SiteDataLock'"
                />
              </div>
              <div v-if="!canQualityAccess" class="p-2">
                <b-btn
                  variant="primary"
                  class="create-btn2 fs-12 mr-3"
                  @click="createSiteForm()"
                  v-if="studyType === 'byinvitation' && user.userRole !== 'Quality' && user.userRole !== 'Biostatistics' && user.userRole !== 'Pharmacovigilance' && user.userRole !== 'Pi' && user.userRole !== 'SubPi' && user.userRole !== 'StudyCoordinator' && user.userRole !== 'HomeHealth' && user.userRole !== 'CallCenter' && user.userRole !== 'Rater' && user.userRole !== 'SiteDataLock'"
                  >Create a site</b-btn
                >
              </div>
              <div v-if="(canStudyAdminAccess || canStudyManagerAccess) && !canSystemAdminAccess" class="p-2">
                <b-btn variant="primary" class="configure-notification" v-if="(canStudyAdminAccess || canStudyManagerAccess) && !canSystemAdminAccess" @click="configureNotification()">Configure notifications</b-btn>
              </div>
              <div v-if="canStudyAdminAccess || canSystemAdminAccess || canSupportAccess" class="p-2">
                <b-btn variant="primary" class="configure-notification" v-if="canStudyAdminAccess || canSystemAdminAccess || canSupportAccess" @click="setGlobalSiteSettings()">Global site settings</b-btn>
              </div>
            </div>
          </div>
        </div>
        <!-- Table for all research sites details -->
        <b-row class="p-0">
          <b-col cols="12">
            <b-row class="pb-20">
              <b-col cols="2" class="header-text">
                PI NAME
              </b-col>
              <b-col cols="1" class="header-text">
                SITE ID
              </b-col>
              <b-col cols="1" class="header-text">
                SITE NAME
              </b-col>
              <b-col cols="2" class="header-text">
                SITE COUNTRY
              </b-col>
              <b-col cols="2" class="header-text">
                SITE LANGUAGE
              </b-col>
              <b-col cols="2" class="header-text">
                SITE STATUS
              </b-col>
              <b-col cols="2" class="header-text">
                PI STATUS
              </b-col>
            </b-row>
            <!-- Each site detail row -->
            <b-row class="site-card mb-10" align-v="center" v-for="(site, pIndex) in researchSites" :key="pIndex">
              <b-col cols="2">
                <span v-if="site.sitePI">
                  <img class="profile-img-size" src="/static/img/profile.png" alt="user-img" />
                  <span class="name fs-14 pt-3"
                    ><b> {{ site.sitePI.firstName }} {{ site.sitePI.lastName }} </b></span
                  >
                </span>
              </b-col>
              <b-col cols="1">
                <span class="word-break">{{ site.userSiteId }}</span>
              </b-col>
              <b-col cols="1">
                <span class="word-break">{{ site.name }}</span>
              </b-col>
              <b-col cols="2">
                <span class="word-break">
                  <span v-for="(country, index) in site.countryNameList" :key="index">
                    <span v-if="index < site.countryNameList.length - 1"> {{ country }}, </span>
                    <span v-if="index == site.countryNameList.length - 1">
                      {{ country }}
                    </span>
                  </span>
                </span>
              </b-col>
              <b-col cols="2">
                <span class="">
                  {{ getSiteLanguages(site) }}
                </span>
              </b-col>
              <b-col cols="2">
                <span class="text-warning" v-if="site.status == 'Pending'">{{ site.status }}</span>
                <span class="text-success" v-if="site.status == 'Active'">{{ site.status }}</span>
                <span class="text-danger" v-if="site.status == 'Inactive'">{{ site.status }}</span>
              </b-col>
              <b-col cols="1">
                <span v-if="site.sitePI">
                  <span class="text-warning" v-if="site.sitePI.status == 'Pending'">{{ site.sitePI.status }}</span>
                  <span class="text-success" v-if="site.sitePI.status == 'Active'">{{ site.sitePI.status }}</span>
                  <span class="text-danger" v-if="site.sitePI.status == 'Inactive'">{{ site.sitePI.status }}</span>
                </span>
              </b-col>
              <b-col cols="1">
                <b-link @click="viewSiteDetails(site)">
                  <i class="fa fa-caret-right pull-right fs-24 icon-color" aria-hidden="true" v-b-tooltip.hover title="Go to Site details"></i>
                </b-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <!-- Global Site Settings Popup -->
    <div v-if="canStudyAdminAccess || canSystemAdminAccess || canSupportAccess" class="modal fade" id="global-site-settings-popup" role="dialog">
      <GlobalSiteSettingsPopup></GlobalSiteSettingsPopup>
    </div>
  </div>
</template>

<script>
import sortBy from "lodash/sortBy";
import { mapGetters } from "vuex";
import { STUDY_ADMIN, STUDY_MANAGER, QUALITY, SYSTEM_ADMIN, SUPPORT } from "@/constants/authRoles";
import { AclRule } from "vue-acl";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import GlobalSiteSettingsPopup from "./global-site-settings-popup.vue";
import _ from "lodash";

export default {
  name: "research-site",
  data() {
    return {
      studyId: this.$route.params.studyId,
      searchTerm: "",
      researchSites: [],
      studyData: {},
      studyType: ""
    };
  },
  components: {
    GlobalSiteSettingsPopup
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canSystemAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    }
  },
  mounted() {
    this.getStudyData();
    this.getSiteDetails();
  },
  methods: {
    getStudyData() {
      this.$api
        .getStudyDataFact(this.studyId)
        .then(response => {
          this.studyData = response.body;
          this.studyType = this.studyData.onboardingType.toLowerCase();
        })
        .catch(error => {
          const { message = "Error while getting study data" } = (error && error.body) || {};
          this.$toastr.error(message);
        });
    },
    getSiteLanguages(approvedLanguages) {
      const languages = [];
      const linkedLanguages = [];
      if (approvedLanguages.linkedCountryLanguages) {
        // eslint-disable-next-line no-unused-vars
        Object.entries(approvedLanguages.linkedCountryLanguages).forEach(([key, val]) => {
          val.forEach(o => {
            linkedLanguages.push(o.display_name);
          });
        });
      }
      if (approvedLanguages.approvedSiteLanguages) {
        // eslint-disable-next-line no-unused-vars
        Object.entries(approvedLanguages.approvedSiteLanguages).forEach(([key, val]) => {
          val.forEach(o => {
            languages.push(o);
          });
        });
      }
      let approvedList = [];
      const overallLanguagesList = [];
      if (!!languages && !!linkedLanguages) {
        approvedList = languages.filter(data => linkedLanguages.includes(data.display_name));
      }
      if (approvedList) {
        approvedList.forEach(o => {
          overallLanguagesList.push(o.display_name);
        });
      }
      const uniqeLanguages = _.uniq(overallLanguagesList);
      const sortedLanguages = uniqeLanguages.sort();
      return sortedLanguages.join(", ");
      // let arr = _.values(approvedLanguages);
      // let languages =  [].concat.apply([], arr)
      // let filteredLanguages = languages && languages.map((language) => ({
      //     language_id: language.language_id,
      //     display_name:language.display_name
      // }));
      // return [...new Map(filteredLanguages.map(language => [language['display_name'], language])).values()];
    },

    getSiteDetails() {
      nprogress.start();
      this.$api.getSitesFact(this.studyId).then(
        response => {
          this.researchSites = sortBy(response.body, "createdTime");
          this.researchSites.filter(data => {
            data.countryNameList.sort();
          });
          nprogress.done();
        },
        error => {
          nprogress.done();
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the list of sites");
        }
      );
    },

    searchSite(searchTerm) {
      if (searchTerm.trim().length > 0) {
        this.$api.searchSitesFact(this.studyId, searchTerm).then(
          response => {
            this.researchSites = sortBy(response.body, "createdTime");
            this.researchSites.filter(data => {
              data.countryNameList.sort();
            });
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the list of sites");
          }
        );
      } else {
        this.getSiteDetails();
      }
    },

    createSiteForm() {
      this.$router.push({ name: "add-research-site" });
    },

    viewSiteDetails(site) {
      this.$router.push({
        name: "research-site-details",
        params: { siteId: site.id }
      });
    },
    //Research Site configure notificattion button
    configureNotification() {
      this.$router.push({ name: "research-site-notifications" });
    },
    setGlobalSiteSettings() {
      window.$("#global-site-settings-popup").modal({ backdrop: "static", keyboard: false }, "show");
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/assets/variables.scss";

.component {
  background-color: $color_content_background;
}

.icon-color {
  color: #d3dfe4;
}

.sec_text {
  color: #666669;
}

.create-btn {
  border-radius: 100px;
  border: none;
  width: 150px;
  height: 40px;
  background-color: #4c8ce4;
}

.search-field {
  padding: 10px !important;
  background-image: url("/static/img/search.svg");
  background-repeat: no-repeat;
  background-position: 97% 50%;
  width: 300px;
}

.create-btn2 {
  background-color: #4c8ce4;
  margin: 0px -15px 0px 0px;
}

.header-text {
  font-weight: bold;
  color: #666669 !important;
  opacity: 0.5;
  font-size: 12px;
}

.profile-img-size {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.site-card {
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  padding: 20px 0px;
}
.configure-notification {
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #4c8ce4;
  width: 150px;
  height: 30px;
  border: solid 1px #4c8ce4;
  background-color: #ffffff;
  margin-left: 10px;
}

.configure-notification:hover {
  color: #4c8ce4 !important;
  border: solid 1px #4c8ce4 !important;
  background-color: #ffffff !important;
}
</style>
